export default __webpack_public_path__ + "static/news-section-outside2-image-f26f5e571dfbc8236f59ab7c23632198.webp";